<template>
	<!-- <v-container v-if="category" class="main pa-0" fluid fill-height>
		<v-container style="width:100%;max-width:1000px;">
			<v-img
				:src="
					getImgUrl(
						`${userDevice === 'desktop' ? 'desktop-' : ''}${category}.png`,
					)
				"
				:lazy-src="
					getImgUrl(
						`${userDevice === 'desktop' ? 'desktop-' : ''}${category}-min.png`,
					)
				"
				:max-width="userDevice === 'desktop' ? 600 : 400"
				:class="{ 'mx-auto': userDevice === 'mobile' }"
			></v-img>
		</v-container>
	</v-container> -->
	<v-img
		contain
		position="center right"
		:min-height="userDevice === 'desktop' ? 300 : 200"
		max-height="500"
		style="background-color:#F8F8FA;"
		:src="getImgUrl(`${userDevice}-background.png`)"
		class="d-flex align-center"
		:class="{
			'px-12': userDevice === 'desktop',
			'px-5': userDevice === 'mobile',
		}"
	>
		<div style="max-width:900px;" class="mx-auto">
			<v-img
				:src="getImgUrl(`${userDevice}-${header}.png`)"
				:max-width="userDevice === 'desktop' ? 500 : 170"
				:class="{ 'mb-8': userDevice === 'desktop' }"
			></v-img>
		</div>
	</v-img>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	props: {
		category: {
			required: true,
		},
	},
	computed: {
		...mapGetters(['userDevice']),
		header() {
			return [
				'afraid',
				'pressure',
				'hit-a-wall',
				'resolutions-short-lived',
				'for-business',
			].includes(this.category)
				? this.category
				: 'default'
		},
	},
	methods: {
		getImgUrl(pic) {
			return require('@/assets/img/header/' + pic)
		},
	},
}
</script>

<style lang="scss" scoped>
.main {
	min-height: 250px;
}
.review-bubble {
	background-color: #fff;
	border: 5px solid #0b61fa;
}

@media screen and (min-width: 600px) {
	.main {
		background: url('https://image.tella.co.kr/v3/trials/header.jpg') no-repeat
			left center;
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
		background-size: cover;
		height: 500px;
		margin-bottom: 30px;
	}
}
</style>
